import { gql } from '@apollo/client';

const GetUnreadNotificationsQuery = gql`
  query GetUnreadNotificationsQuery {
    getUnreadNotifications {
      id
    }
  }
`;

export default GetUnreadNotificationsQuery;
